import Nullstack from 'nullstack';
export default function IconShapeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-shape-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3.575 3.597a2 2 0 0 0 2.849 2.808"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M17.574 17.598a2 2 0 0 0 2.826 2.83"
  }), "   ", Nullstack.element("path", {
    d: "M5 7v10"
  }), "   ", Nullstack.element("path", {
    d: "M9 5h8"
  }), "   ", Nullstack.element("path", {
    d: "M7 19h10"
  }), "   ", Nullstack.element("path", {
    d: "M19 7v8"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}